import script from "./RankTable.vue?vue&type=script&setup=true&lang=js"
export * from "./RankTable.vue?vue&type=script&setup=true&lang=js"

import "./RankTable.vue?vue&type=style&index=0&id=c669793c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c669793c"]])

export default __exports__